import { useEffect, useRef, useState } from 'react';
import ImagenBannerPALOMA from '../../assets/images/PALOMA.jpg';
import './Paloma.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function PALOMA() {

    
  return (
    <>
    <div className="infra-banner-PALOMA">
  <img src={ImagenBannerPALOMA} alt="PALOMA" className="banner-img-PALOMA" />
    <h1 className="banner-texto-PALOMA">LA PALOMA</h1>
</div>
<div className="fondo-blanco-PALOMA">
<div className="contenedor-PALOMA">
  <div className="columna-izquierda-PALOMA">
    <h1>SECTOR:</h1>
    <p>MATERIALES TÉCNICOS</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
      <p>La Paloma es una empresa mexicana con más de seis décadas de experiencia en la comercialización de metales y plásticos de ingeniería como cobre, aluminio, acero, bronce, PVC, acrílicos y Nylomaq, entre otros. Su amplio portafolio le permite atender una diversidad de industrias como la automotriz, eléctrica, construcción, alimentaria y hospitalaria, posicionándose como un proveedor integral en el mercado nacional.<br>
      </br>
      <br></br>
      Con más de 20 sucursales distribuidas estratégicamente por México, La Paloma ofrece soluciones técnicas, materiales certificados y atención especializada que respaldan proyectos industriales a gran escala. Su enfoque en servicio, calidad y cobertura logística la consolida como una empresa sólida, confiable y de referencia en el desarrollo productivo del país.

    </p>
    <div className="boton-reto-PALOMA">
      <a href="https://www.immsa.mx/" className="btn-reto-PALOMA">Ver más información</a>
    </div>
  </div>

  <div className="columna-derecha-PALOMA">
    <h2>RETO DEL PROYECTO: OPTIMIZACIÓN OPERATIVA MEDIANTE LA ESTANDARIZACIÓN DE PROCESOS E IMPLEMENTACIÓN DE ERP.</h2>
    <p>El crecimiento sostenido de la empresa marcó un hito estratégico que impulsó la adopción de un sistema ERP (Enterprise Resource Planning), con el objetivo de optimizar el control administrativo y operativo tanto del corporativo como de cada una de las sucursales que lo conforman. <br></br>
    <br></br>Es necesario estandarizar los procesos operativos en todas las sucursales, para garantizar la consistencia y confiabilidad de la información registrada en el sistema.
</p>

    <h2>SOLUCIÓN IMPLEMENTADA: OPTIMIZACIÓN DE PROCESOS Y TRANSFORMACIÓN DIGITAL EMPRESARIAL.</h2>
    <p>La solución fue desarrollada de manera conjunta por dos de nuestras áreas especializadas: Asesoría Empresarial y Consultoría en Implementación de ERP, combinando experiencia operativa y tecnológica para abordar el reto de transformación. <br></br>
    <br></br>
    Desde el área de Asesoría Empresarial, se realizó un análisis exhaustivo de los procesos operativos en cada sucursal. Esta revisión permitió identificar oportunidades de mejora y establecer controles clave que sirvieron como base para el diseño de la solución propuesta en el proyecto. <br></br>
    <br></br>
    Por su parte, el equipo de Consultoría en ERP se encargó de revisar la configuración del sistema de acuerdo con los flujos de trabajo definidos en el análisis previo, asegurando que la funcionalidad del ERP se alineará con los nuevos controles operativos. Esta adaptación garantizó que el sistema respondiera eficazmente a las necesidades reales de la operación. <br></br>
<br></br>
    Gracias a una gestión eficiente del proyecto, se logró cumplir con los plazos establecidos, optimizando recursos y reduciendo significativamente los costos asociados a la implementación. <br></br>
    <br></br>
    Como resultado, se logró una implementación sólida y sostenible del ERP, permitiendo el cierre diario de operaciones en cada sucursal con información confiable y alineada a los requerimientos corporativos.
</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default PALOMA;